import React from "react";

const UserDetailSkeleton = () => {
  return (
    <div>
      {/* User Info Skeleton */}
      <div className="flex justify-center mt-6">
        <div className="bg-white rounded-2xl shadow-sm p-6 w-full max-w-4xl animate-pulse">
          <div className="flex flex-col items-center">
            <div className="w-28 h-28 rounded-full bg-gray-300"></div>
            <div className="mt-4 h-5 w-40 bg-gray-300 rounded"></div>
          </div>

          {/* Skeleton Grid */}
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            {[...Array(6)].map((_, i) => (
              <div key={i}>
                <div className="h-4 w-20 bg-gray-300 rounded mx-auto mb-2"></div>
                <div className="h-5 w-28 bg-gray-200 rounded mx-auto"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tabs Skeleton */}
      <div className="flex justify-center mt-8">
        <div className="w-full max-w-4xl bg-white p-6 rounded-2xl shadow-sm animate-pulse">
          <div className="flex justify-center border-b mb-6 space-x-6">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-6 w-32 bg-gray-300 rounded"></div>
            ))}
          </div>

          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex justify-between items-center">
                <div className="h-5 w-40 bg-gray-300 rounded"></div>
                <div className="h-6 w-28 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailSkeleton;
